/* tslint:disable */
/* eslint-disable */
/**
 * Theia Cloud API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.11.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI } from './base';
/**
 * RootResourceApi - axios parameter creator
 * @export
 */
export const RootResourceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Replies if the service is available.
         * @summary Ping
         * @param {string} appId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAppIdGet: async (appId, options = {}) => {
            // verify required parameter 'appId' is not null or undefined
            assertParamExists('serviceAppIdGet', 'appId', appId);
            const localVarPath = `/service/{appId}`
                .replace(`{${"appId"}}`, encodeURIComponent(String(appId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication SecurityScheme required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "SecurityScheme", [], configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Launches a session and creates a workspace if required. Responds with the URL of the launched session.
         * @summary Launch Session
         * @param {LaunchRequest} [launchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        servicePost: async (launchRequest, options = {}) => {
            const localVarPath = `/service`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication SecurityScheme required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "SecurityScheme", [], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(launchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RootResourceApi - functional programming interface
 * @export
 */
export const RootResourceApiFp = function (configuration) {
    const localVarAxiosParamCreator = RootResourceApiAxiosParamCreator(configuration);
    return {
        /**
         * Replies if the service is available.
         * @summary Ping
         * @param {string} appId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async serviceAppIdGet(appId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.serviceAppIdGet(appId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Launches a session and creates a workspace if required. Responds with the URL of the launched session.
         * @summary Launch Session
         * @param {LaunchRequest} [launchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async servicePost(launchRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.servicePost(launchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * RootResourceApi - factory interface
 * @export
 */
export const RootResourceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RootResourceApiFp(configuration);
    return {
        /**
         * Replies if the service is available.
         * @summary Ping
         * @param {string} appId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAppIdGet(appId, options) {
            return localVarFp.serviceAppIdGet(appId, options).then((request) => request(axios, basePath));
        },
        /**
         * Launches a session and creates a workspace if required. Responds with the URL of the launched session.
         * @summary Launch Session
         * @param {LaunchRequest} [launchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        servicePost(launchRequest, options) {
            return localVarFp.servicePost(launchRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RootResourceApi - object-oriented interface
 * @export
 * @class RootResourceApi
 * @extends {BaseAPI}
 */
export class RootResourceApi extends BaseAPI {
    /**
     * Replies if the service is available.
     * @summary Ping
     * @param {string} appId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RootResourceApi
     */
    serviceAppIdGet(appId, options) {
        return RootResourceApiFp(this.configuration).serviceAppIdGet(appId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Launches a session and creates a workspace if required. Responds with the URL of the launched session.
     * @summary Launch Session
     * @param {LaunchRequest} [launchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RootResourceApi
     */
    servicePost(launchRequest, options) {
        return RootResourceApiFp(this.configuration).servicePost(launchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SessionResourceApi - axios parameter creator
 * @export
 */
export const SessionResourceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * List sessions of a user.
         * @summary List sessions
         * @param {string} appId
         * @param {string} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceSessionAppIdUserGet: async (appId, user, options = {}) => {
            // verify required parameter 'appId' is not null or undefined
            assertParamExists('serviceSessionAppIdUserGet', 'appId', appId);
            // verify required parameter 'user' is not null or undefined
            assertParamExists('serviceSessionAppIdUserGet', 'user', user);
            const localVarPath = `/service/session/{appId}/{user}`
                .replace(`{${"appId"}}`, encodeURIComponent(String(appId)))
                .replace(`{${"user"}}`, encodeURIComponent(String(user)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication SecurityScheme required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "SecurityScheme", [], configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stops a session.
         * @summary Stop session
         * @param {SessionStopRequest} [sessionStopRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceSessionDelete: async (sessionStopRequest, options = {}) => {
            const localVarPath = `/service/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication SecurityScheme required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "SecurityScheme", [], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(sessionStopRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the last activity timestamp for a session to monitor activity.
         * @summary Report session activity
         * @param {SessionActivityRequest} [sessionActivityRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceSessionPatch: async (sessionActivityRequest, options = {}) => {
            const localVarPath = `/service/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication SecurityScheme required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "SecurityScheme", [], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(sessionActivityRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the current CPU and memory usage of the session\'s pod.
         * @summary Get performance metrics
         * @param {string} appId
         * @param {string} sessionName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceSessionPerformanceAppIdSessionNameGet: async (appId, sessionName, options = {}) => {
            // verify required parameter 'appId' is not null or undefined
            assertParamExists('serviceSessionPerformanceAppIdSessionNameGet', 'appId', appId);
            // verify required parameter 'sessionName' is not null or undefined
            assertParamExists('serviceSessionPerformanceAppIdSessionNameGet', 'sessionName', sessionName);
            const localVarPath = `/service/session/performance/{appId}/{sessionName}`
                .replace(`{${"appId"}}`, encodeURIComponent(String(appId)))
                .replace(`{${"sessionName"}}`, encodeURIComponent(String(sessionName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication SecurityScheme required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "SecurityScheme", [], configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Starts a new session for an existing workspace and responds with the URL of the started session.
         * @summary Start a new session
         * @param {SessionStartRequest} [sessionStartRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceSessionPost: async (sessionStartRequest, options = {}) => {
            const localVarPath = `/service/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication SecurityScheme required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "SecurityScheme", [], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(sessionStartRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SessionResourceApi - functional programming interface
 * @export
 */
export const SessionResourceApiFp = function (configuration) {
    const localVarAxiosParamCreator = SessionResourceApiAxiosParamCreator(configuration);
    return {
        /**
         * List sessions of a user.
         * @summary List sessions
         * @param {string} appId
         * @param {string} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async serviceSessionAppIdUserGet(appId, user, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.serviceSessionAppIdUserGet(appId, user, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Stops a session.
         * @summary Stop session
         * @param {SessionStopRequest} [sessionStopRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async serviceSessionDelete(sessionStopRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.serviceSessionDelete(sessionStopRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the last activity timestamp for a session to monitor activity.
         * @summary Report session activity
         * @param {SessionActivityRequest} [sessionActivityRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async serviceSessionPatch(sessionActivityRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.serviceSessionPatch(sessionActivityRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the current CPU and memory usage of the session\'s pod.
         * @summary Get performance metrics
         * @param {string} appId
         * @param {string} sessionName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async serviceSessionPerformanceAppIdSessionNameGet(appId, sessionName, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.serviceSessionPerformanceAppIdSessionNameGet(appId, sessionName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Starts a new session for an existing workspace and responds with the URL of the started session.
         * @summary Start a new session
         * @param {SessionStartRequest} [sessionStartRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async serviceSessionPost(sessionStartRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.serviceSessionPost(sessionStartRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * SessionResourceApi - factory interface
 * @export
 */
export const SessionResourceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SessionResourceApiFp(configuration);
    return {
        /**
         * List sessions of a user.
         * @summary List sessions
         * @param {string} appId
         * @param {string} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceSessionAppIdUserGet(appId, user, options) {
            return localVarFp.serviceSessionAppIdUserGet(appId, user, options).then((request) => request(axios, basePath));
        },
        /**
         * Stops a session.
         * @summary Stop session
         * @param {SessionStopRequest} [sessionStopRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceSessionDelete(sessionStopRequest, options) {
            return localVarFp.serviceSessionDelete(sessionStopRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the last activity timestamp for a session to monitor activity.
         * @summary Report session activity
         * @param {SessionActivityRequest} [sessionActivityRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceSessionPatch(sessionActivityRequest, options) {
            return localVarFp.serviceSessionPatch(sessionActivityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the current CPU and memory usage of the session\'s pod.
         * @summary Get performance metrics
         * @param {string} appId
         * @param {string} sessionName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceSessionPerformanceAppIdSessionNameGet(appId, sessionName, options) {
            return localVarFp.serviceSessionPerformanceAppIdSessionNameGet(appId, sessionName, options).then((request) => request(axios, basePath));
        },
        /**
         * Starts a new session for an existing workspace and responds with the URL of the started session.
         * @summary Start a new session
         * @param {SessionStartRequest} [sessionStartRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceSessionPost(sessionStartRequest, options) {
            return localVarFp.serviceSessionPost(sessionStartRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SessionResourceApi - object-oriented interface
 * @export
 * @class SessionResourceApi
 * @extends {BaseAPI}
 */
export class SessionResourceApi extends BaseAPI {
    /**
     * List sessions of a user.
     * @summary List sessions
     * @param {string} appId
     * @param {string} user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionResourceApi
     */
    serviceSessionAppIdUserGet(appId, user, options) {
        return SessionResourceApiFp(this.configuration).serviceSessionAppIdUserGet(appId, user, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Stops a session.
     * @summary Stop session
     * @param {SessionStopRequest} [sessionStopRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionResourceApi
     */
    serviceSessionDelete(sessionStopRequest, options) {
        return SessionResourceApiFp(this.configuration).serviceSessionDelete(sessionStopRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates the last activity timestamp for a session to monitor activity.
     * @summary Report session activity
     * @param {SessionActivityRequest} [sessionActivityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionResourceApi
     */
    serviceSessionPatch(sessionActivityRequest, options) {
        return SessionResourceApiFp(this.configuration).serviceSessionPatch(sessionActivityRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns the current CPU and memory usage of the session\'s pod.
     * @summary Get performance metrics
     * @param {string} appId
     * @param {string} sessionName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionResourceApi
     */
    serviceSessionPerformanceAppIdSessionNameGet(appId, sessionName, options) {
        return SessionResourceApiFp(this.configuration).serviceSessionPerformanceAppIdSessionNameGet(appId, sessionName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Starts a new session for an existing workspace and responds with the URL of the started session.
     * @summary Start a new session
     * @param {SessionStartRequest} [sessionStartRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionResourceApi
     */
    serviceSessionPost(sessionStartRequest, options) {
        return SessionResourceApiFp(this.configuration).serviceSessionPost(sessionStartRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WorkspaceResourceApi - axios parameter creator
 * @export
 */
export const WorkspaceResourceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Lists the workspaces of a user.
         * @summary List workspaces
         * @param {string} appId
         * @param {string} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceWorkspaceAppIdUserGet: async (appId, user, options = {}) => {
            // verify required parameter 'appId' is not null or undefined
            assertParamExists('serviceWorkspaceAppIdUserGet', 'appId', appId);
            // verify required parameter 'user' is not null or undefined
            assertParamExists('serviceWorkspaceAppIdUserGet', 'user', user);
            const localVarPath = `/service/workspace/{appId}/{user}`
                .replace(`{${"appId"}}`, encodeURIComponent(String(appId)))
                .replace(`{${"user"}}`, encodeURIComponent(String(user)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication SecurityScheme required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "SecurityScheme", [], configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a workspace.
         * @summary Delete workspace
         * @param {WorkspaceDeletionRequest} [workspaceDeletionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceWorkspaceDelete: async (workspaceDeletionRequest, options = {}) => {
            const localVarPath = `/service/workspace`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication SecurityScheme required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "SecurityScheme", [], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(workspaceDeletionRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new workspace for a user.
         * @summary Create workspace
         * @param {WorkspaceCreationRequest} [workspaceCreationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceWorkspacePost: async (workspaceCreationRequest, options = {}) => {
            const localVarPath = `/service/workspace`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication SecurityScheme required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "SecurityScheme", [], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(workspaceCreationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * WorkspaceResourceApi - functional programming interface
 * @export
 */
export const WorkspaceResourceApiFp = function (configuration) {
    const localVarAxiosParamCreator = WorkspaceResourceApiAxiosParamCreator(configuration);
    return {
        /**
         * Lists the workspaces of a user.
         * @summary List workspaces
         * @param {string} appId
         * @param {string} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async serviceWorkspaceAppIdUserGet(appId, user, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.serviceWorkspaceAppIdUserGet(appId, user, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes a workspace.
         * @summary Delete workspace
         * @param {WorkspaceDeletionRequest} [workspaceDeletionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async serviceWorkspaceDelete(workspaceDeletionRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.serviceWorkspaceDelete(workspaceDeletionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a new workspace for a user.
         * @summary Create workspace
         * @param {WorkspaceCreationRequest} [workspaceCreationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async serviceWorkspacePost(workspaceCreationRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.serviceWorkspacePost(workspaceCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * WorkspaceResourceApi - factory interface
 * @export
 */
export const WorkspaceResourceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WorkspaceResourceApiFp(configuration);
    return {
        /**
         * Lists the workspaces of a user.
         * @summary List workspaces
         * @param {string} appId
         * @param {string} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceWorkspaceAppIdUserGet(appId, user, options) {
            return localVarFp.serviceWorkspaceAppIdUserGet(appId, user, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a workspace.
         * @summary Delete workspace
         * @param {WorkspaceDeletionRequest} [workspaceDeletionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceWorkspaceDelete(workspaceDeletionRequest, options) {
            return localVarFp.serviceWorkspaceDelete(workspaceDeletionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new workspace for a user.
         * @summary Create workspace
         * @param {WorkspaceCreationRequest} [workspaceCreationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceWorkspacePost(workspaceCreationRequest, options) {
            return localVarFp.serviceWorkspacePost(workspaceCreationRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WorkspaceResourceApi - object-oriented interface
 * @export
 * @class WorkspaceResourceApi
 * @extends {BaseAPI}
 */
export class WorkspaceResourceApi extends BaseAPI {
    /**
     * Lists the workspaces of a user.
     * @summary List workspaces
     * @param {string} appId
     * @param {string} user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceResourceApi
     */
    serviceWorkspaceAppIdUserGet(appId, user, options) {
        return WorkspaceResourceApiFp(this.configuration).serviceWorkspaceAppIdUserGet(appId, user, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes a workspace.
     * @summary Delete workspace
     * @param {WorkspaceDeletionRequest} [workspaceDeletionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceResourceApi
     */
    serviceWorkspaceDelete(workspaceDeletionRequest, options) {
        return WorkspaceResourceApiFp(this.configuration).serviceWorkspaceDelete(workspaceDeletionRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a new workspace for a user.
     * @summary Create workspace
     * @param {WorkspaceCreationRequest} [workspaceCreationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceResourceApi
     */
    serviceWorkspacePost(workspaceCreationRequest, options) {
        return WorkspaceResourceApiFp(this.configuration).serviceWorkspacePost(workspaceCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
//# sourceMappingURL=api.js.map